import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from './Layout';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Laden…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Trainer gehören in ihre eigene mobile Oberfläche
  if (user.rolle === 'trainer') {
    return <Navigate to="/trainer/gruppen" replace />;
  }

  return <Layout>{children}</Layout>;
}
